import React from 'react'
import EventManager from "../../../../services/EventManager";
import { useTranslation } from '../../../../contexts/TranslationProvider';
import '../buttons.scss'

const CommitProjectTemplate = () => {
    const { t } = useTranslation();
    const handleSaveProjectTemplate = async () => {
        EventManager.invoke('ActivateProjectTemplate', true)
    };
    return (
        <button className="navbar-button" onClick={handleSaveProjectTemplate}>
            {t("navbar.commitProjectTemplate")}
        </button>
    )
}

export default CommitProjectTemplate